import { render, staticRenderFns } from "./WebinarTopMenu.vue?vue&type=template&id=07848cd6"
import script from "./WebinarTopMenu.vue?vue&type=script&lang=js"
export * from "./WebinarTopMenu.vue?vue&type=script&lang=js"
import style0 from "./WebinarTopMenu.vue?vue&type=style&index=0&id=07848cd6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07848cd6')) {
      api.createRecord('07848cd6', component.options)
    } else {
      api.reload('07848cd6', component.options)
    }
    module.hot.accept("./WebinarTopMenu.vue?vue&type=template&id=07848cd6", function () {
      api.rerender('07848cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Webinar/Menu/WebinarTopMenu.vue"
export default component.exports